import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackEmotionRatingListing from "../EmotionRating/FeedbackEmotionRatingListing";
import { ErrorMessage } from "./ErrorMessage";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question6FlashCoachExperience = ({
  flashCoachTrainingRating,
  updateEmotionRatingFormData,
  validationError,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "How would you rate the training provided prior to using the system?*"
          }
        />
        <FeedbackEmotionRatingListing
          inputID={"flashCoachTrainingRating"}
          emotionRatingList={flashCoachTrainingRating}
          updateEmotionRatingFormData={updateEmotionRatingFormData}
        />
        {validationError?.error && (<ErrorMessage text={validationError.error} />)}

      </FeedbackFormLayout>
    </>
  );
};
